import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Spinner,
} from 'reactstrap';

// import EditForms from './main-page-elements/EditForms';
import EditFormsAlternate from './main-page-elements/EditFormsAlternate';
import LanguageModifyButtons from './main-page-elements/LanguageModifyButtons';
import LanguageSelectButton from './main-page-elements/LanguageSelectButton';
import AddModal from './main-page-elements/AddModal';
import DeleteModal from './main-page-elements/DeleteModal';

import { validateTranslations } from '../../actions/translations';

class Main extends React.PureComponent {
  componentDidMount() {
    const { site } = this.props;

    // Validate the theme version and update if needed.
    validateTranslations(site);
    this.intervalID = window.setInterval(() => validateTranslations(site), 8000);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({ type: 'EDIT_TRANSITION_OBJECT', payload: false });
    dispatch({ type: 'RESET_TRANSITION_OBJECT' });
    dispatch({ type: 'LOADING_TRANSITION_OBJECT', payload: true });
    window.clearInterval(this.intervalID);
  }

  render() {
    const {
      tab,
      translations,
      loading,
      edit,
      site,
      siteName,
    } = this.props;

    if (loading) {
      return <main className="p-5"><Spinner /></main>;
    }

    const titles = Object.keys(translations[tab]);

    return (
      <main className="p-5">
        <Row>
          <Col>
            <h2 className="mb-3 font-weight-bold">
              {siteName}
              &nbsp;Portal
            </h2>
          </Col>
          <LanguageModifyButtons site={site} />
        </Row>
        <LanguageSelectButton />
        <EditFormsAlternate
          tab={tab}
          titles={titles}
          edit={edit}
          translations={translations}
        />
        <AddModal site={site} />
        <DeleteModal site={site} />
      </main>
    );
  }
}

const mapStateToProps = (store) => ({
  tab: store.translations.tab,
  translations: store.translations.sets,
  saving: store.translations.saving,
  loading: store.translations.loading,
  edit: store.translations.edit,
});

export default connect(mapStateToProps)(Main);
